import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { appStorage } from "helpers";

import { AuthForm } from '../../';

import {
  sendLoginWhithKey,
} from "../../authSlice";

export function Restricted(props) {
  const dispatch = useDispatch();
  let isAuth = useSelector(state => state.auth.isAuth);

  useEffect(() => {
    const authkey = appStorage.getItem("authkey");
    const key = appStorage.getItem("key");

    if (authkey || key) {
      dispatch(sendLoginWhithKey({ authkey, key }));
    }
  }, [dispatch]);

  return (<>
    {!isAuth && !props.forcedAuth ? <AuthForm /> : props.children}
  </>
  );
}
